import React from 'react';

function Header() {
  return (
    <header className="bg-white shadow">
      <div className="container mx-auto p-4">
        <h1 className="text-2xl font-semibold text-gray-800">
          Compar'Immo – Simulation d'achat immobilier vs location
        </h1>
      </div>
    </header>
  );
}

export default Header; 